export default __webpack_public_path__ + "static/media/submitRequest.1117f4a7.svg";